import { AuthConfig } from 'angular-oauth2-oidc';
import { CURRENT_ENTITY, ENTITY_VARS } from '../shared/constants/entity-vars';
export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: ENTITY_VARS[CURRENT_ENTITY].issuer,
  // Logout Url of the Identity Provider
  logoutUrl: ENTITY_VARS[CURRENT_ENTITY].logoutUrl,
  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/auth',
  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: ENTITY_VARS[CURRENT_ENTITY].clientId,
  //clientId: 'bpostb2b_fulfilment_np',
  responseType: 'code',
  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. Also provide user sepecific
  scope: 'openid',
  showDebugInformation: false,
  checkOrigin: false,
};
/**
 * oidc : false
 * we have added because of following error *
 * error occured if property oidc is true, the received user-id (sub) has to be the user-id of the user that has logged in with oidc. if you are not using oidc but just oauth2 password flow set oidc to false
 */
